<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.interests.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!interestsItems.length" class="panel--empty">
                    <center>{{$t('dashboard.interests.no_interests')}}</center>
                </div>
                <div v-else class="tags">
                    <span class="tags__tag tags__tag_inline" v-for="(item, index) in interestsItems" :key="`study_${item.id}_${index}`">
                        <span>{{item.name}}</span>
                    </span>
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.interests.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.interests.see_all')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component({})
    export default class InterestsPanel extends Vue {
        name = 'interests-panel';
        expanded = false;

        get interestsItems() {
            return this.$store.state.profile.profile.interests || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.interestsItems.length && this.interestsItems.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/InterestsPanel.vue